/**
 *
 * お店の検索用Tags
 *
 */
import { firestore } from 'firebase';
import DatabaseAdapter from 'src/firebase/db/DatabaseAdapter';
import ValidationManager, { ValidationResponse } from 'src/firebase/db/ValidationManager';

const tagInitialEntity = {
  id: '',
  name: '',
  is_deleted: false,
  is_published: false,
  created_at: {} as firestore.FieldValue,
  updated_at: {} as firestore.FieldValue,
};
export type TagEntity = typeof tagInitialEntity;
export const tagEntityKeys = (Object.keys(tagInitialEntity) as unknown) as (keyof TagEntity)[];

class TagsDB extends DatabaseAdapter {
  private MAX_COUNT = 30;

  constructor(props: any) {
    super(props);
    this.setSchemaKeys(tagEntityKeys);
  }

  getValidationErrors(query: Partial<TagEntity>): ValidationResponse | null {
    const validator = new ValidationManager();
    tagEntityKeys.forEach((key) => {
      switch (key) {
        case 'name': {
          const value = query[key];
          validator.isString(key, value);
          if (typeof value === 'string') validator.validateMaxLength(key, value, 140);
          break;
        }
        case 'is_deleted':
        case 'is_published':
          validator.isBoolean(key, query[key]);
      }
    });
    return validator.isPass() ? null : validator.throwValidateError(validator.getErrors());
  }

  update(query: Partial<TagEntity>) {
    const filteredQuery = this.filterQuery(query);
    const validationErrors = this.getValidationErrors(filteredQuery);
    if (validationErrors) return validationErrors;

    const requestQuery = {
      ...filteredQuery,
      updated_at: this.getServerTimeStamp(),
    };
    console.log('postQuery:tag update', requestQuery);

    return this.getDocumentRef(filteredQuery.id!)
      .update(requestQuery)
      .then(async () => {
        const d = await this.getDocument(filteredQuery.id!);
        return this.formatSuccess(d);
      })
      .catch((err) => {
        console.log(err);
        return this.throwError(500, 'System Error');
      });
  }

  create(query: Partial<TagEntity>) {
    const filteredQuery = this.filterQuery(query);
    const validationErrors = this.getValidationErrors(filteredQuery);
    if (validationErrors) return validationErrors;

    const requestQuery = {
      ...filteredQuery,
      id: '',
      created_at: this.getServerTimeStamp(),
      updated_at: this.getServerTimeStamp(),
    };
    console.log('postQuery:tag create', requestQuery);

    const ref = this.getConnection();
    return ref
      .add(requestQuery)
      .then(async (snapshot) => {
        const id = snapshot.id;
        await ref.doc(snapshot.id).update({
          id: id,
        });
        return this.formatSuccess({
          id: id,
        });
      })
      .catch((err) => {
        console.log(err);
        return this.throwError(500, 'System Error');
      });
  }

  getAllTags() {
    const tags: TagEntity[] = [];
    return this.getConnection()
      .where('is_deleted', '==', false)
      .limit(this.MAX_COUNT)
      .get()
      .then((snapshot) => {
        if (snapshot.empty) {
          console.log('No matching documents.');
          return this.throwError(44, '存在しない値です');
        }
        snapshot.forEach((doc) => {
          tags.push(doc.data() as TagEntity);
        });
        return this.formatSuccess(tags);
      })
      .catch((err) => {
        console.log('Error getting documents', err);
        return this.throwError(500, 'System Error');
      });
  }
}

export default new TagsDB({
  schema: 'tags',
});
